import React, { useContext } from 'react'
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import MapMarker from './MapMarker'
import Categories from '../Filter/Categories';
import { useMediaQuery } from 'react-responsive'
import { SiteContext } from '../../context/siteContext';

export default function Map(props) {

    const { markers } = useContext(SiteContext)

    const containerStyle = {
        width: '100%',
        height: '850px'
    };

    const containerStyleSmall = {
        width: '100%',
        height: '300px'
    };

    const center = {
        lat: 55.87294734079599,
        lng: -4.24858517061758
    };

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyCA17XufYl3oox1qRT6aXvvM8JqmyvGC1I"
    });

    const bigScreen = useMediaQuery({ query: '(min-width: 1000px)' })
    const smallScreen = useMediaQuery({ query: '(max-width: 1000px)' })

    return isLoaded ? (
        <div>
            {bigScreen ?
                <div className="row row-cols-2">
                    <div className="col-9">
                        <GoogleMap id="google-map" mapContainerStyle={containerStyle} zoom={10} center={center}>
                            {markers.map(function (marker,id) {
                                return (
                                    <MapMarker key={id} name={marker.name} marker={marker.Address} />
                                )
                            })}
                        </GoogleMap>
                    </div>
                    <div className="col-3">
                        <Categories brand={props.brand} bigScreen={true} />
                    </div>
                </div>
                :
                smallScreen ?
                    <>
                        <div className="row row-cols-1">
                            <div className="col">
                                <GoogleMap id="google-map" mapContainerStyle={containerStyleSmall} zoom={10} center={center}>
                                    {markers.map(function (marker, id) {
                                        //setB(marker.Contact.name)
                                        return (
                                            <MapMarker key={id} name={marker.name} marker={marker.Address} />
                                        )
                                    })}
                                </GoogleMap>
                            </div>
                        </div>
                        <div className="row my-4 mx-2">
                            <Categories brand={props.brand} bigScreen={false} />
                        </div>
                    </>
            : <></>
            }
        </div>
    ) : <></>
}
